import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  private http = inject(HttpClient);

  public coords: { lat: number | null; lon: number | null } = {
    lat: null,
    lon: null,
  };

  public location: any = null;
  public address: string = '';

  getCurrentPosition(): Observable<any> {
    return new Observable((observer) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position: GeolocationPosition) => {
            observer.next(position);
            observer.complete();
          },
          (error) => {
            observer.error(error);
          }
        );
      } else {
        observer.error('Geolocation is not available in this browser.');
      }
    });
  }

  getLocation(): void {
    this.getCurrentPosition().subscribe({
      next: (position) => {
        this.coords.lon = position.coords.longitude;
        this.coords.lat = position.coords.latitude;
        if (this.coords.lat !== null && this.coords.lon !== null) {
          this.callApi(this.coords.lon, this.coords.lat).subscribe((data) => {
            this.location = data;
            this.address = data?.features?.[0]?.properties?.label;
          });
        }
      },
      error: (error) => {
        console.log('Error getting geolocation:', error);
      },
    });
  }

  callApi(
    Longitude: number,
    Latitude: number
  ): Observable<{ type: string; features: any[] }> {
    const url = `https://api-adresse.data.gouv.fr/reverse/?lon=${Longitude}&lat=${Latitude}`;
    return this.http.get<{ type: string; features: any[] }>(url);
  }
}
